export const getDataAttributes = (data = {}) => ({
  'data-content': data.content,
  'data-content-category': data.contentCategory,
  'data-content-category-id': data.contentCategoryId,
  'data-content-id': data.contentId,
  'data-content-position': data.contentPosition,
  'data-content-title': data.contentTitle,
  'data-location': data.location,
  'data-screen-size': data.screenSize,
  'data-type': data.type,
  'data-url': data.url
});